import { useFormContext } from "react-hook-form";

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

import { type FormControlProps } from "./types";

export const DropdownFormControl = ({ field, name }: FormControlProps) => {
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      render={(context) => (
        <FormItem>
          <FormLabel>{field.title}</FormLabel>
          <Select
            onValueChange={context.field.onChange}
            defaultValue={context.field.value}
            value={context.field.value}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder={field.title} />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {field.options?.map((option) => (
                <SelectItem key={option.key} value={option.key}>
                  {option.value}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          {field.description && (
            <FormDescription>{field.description}</FormDescription>
          )}
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
